import React from 'react';
import styles from './TextInput.module.css';
import { TextInputProps } from './types';

export const TextInput = ({
    text,
    value,
    onChange,
    onBlur,
}: TextInputProps) => {
    return (
        <div className={styles.textinput}>
            <textarea
                placeholder={text}
                className={styles.input}
                value={value}
                onChange={e => onChange(e.target.value)}
                onBlur={onBlur}
            />
        </div>
    );
};
